export default {
  niDemo: false,
  i18n: {
    userLanguages: ['en-US'],
    fallbackLng: 'en-US',
  },
  payrolls: {
    enabled: true,
  },
   ownAccountTransfer: {
    enabled: true,
  },
  showCaptcha: true,
};
